import React from 'react';
import ReactQuill from 'react-quill';
import { modules, formats } from '../../../constants/baseConst';


const TextArea = ({ value, handleChange, setQuillRef, hadleSubmit, title }) => {
    const handleChangeDescription = (value) => {
        handleChange(value);
    }
    return (
        <div className="_container_records">
            <div className="_add_webinar new-webinar">
                <h3>{title}:</h3>
                <ReactQuill
                    ref={setQuillRef}
                    name={'title'}
                    placeholder={'Start writing text here. Add text, photo and link.'}
                    defaultValue={value}
                    value={value || ''}
                    onChange={handleChangeDescription}
                    modules={modules}
                    formats={formats}
                    className={`quill-toolbar-position`}
                />
                <button className='button_classic mt-20' type='button' onClick={()=>hadleSubmit()}>
                    Save
                </button>
            </div>
        </div>
    );
}

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/Admin/Settings/TextArea.jsx